export const askToRefreshSalesforceWrapper = (targetOrigin: string, mapId?: number) => {
  window.parent.postMessage({ type: 'sf:refresh', mapId }, targetOrigin);
};
